module.exports = __webpack_public_path__ + "img/banner.cc7e5ba.png";